import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * New Zealand IRD generator following Single Responsibility Principle
 */
export class NzGenerator extends BaseGenerator {
  generate() {
    let ird;
    let attempts = 0;
    
    do {
      // Generate 8 random digits
      ird = this.randomDigits(8);
      attempts++;
    } while (!this.isValidIrd(ird) && attempts < 100);

    return ird + this.calculateCheckDigit(ird);
  }

  calculateCheckDigit(digits) {
    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < 8; i++) {
      sum += parseInt(digits[i]) * weights[i];
    }

    const remainder = sum % 11;
    if (remainder === 0) return '0';
    if (remainder === 1) return null; // Invalid
    return (11 - remainder).toString();
  }

  isValidIrd(digits) {
    return this.calculateCheckDigit(digits) !== null;
  }
}